import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * Fallback de Suspense pendant le téléchargement d'un chunk de route.
 *
 * Volontairement minimal : ce composant vit dans main.js, donc il ne doit
 * importer que des modules déjà présents (imports profonds @mui/material,
 * pas de barrel).
 *
 */
export default function PageLoader() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        minHeight: 240,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
